import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import {
  MODAL_CLIENT_CANCEL_TRANSACTION,
  MODAL_CLIENT_SELECTION_TRANSFERT,
  MODAL_CLIENT_BAR_MODAL
} from 'redux/modules/modals'
import ReceiptIcon from '@material-ui/icons/Receipt'
import EditIcon from '@material-ui/icons/Edit'
import SwapIcon from '@material-ui/icons/SwapHoriz'
import DeleteIcon from '@material-ui/icons/Delete'
import * as Colors from '@material-ui/core/colors'
const runningColor = Colors.lightGreen['500']
const pauseColor = Colors.orange['400']
const styles = theme => ({
  button: {
    margin: 10
  },
  playButton: {
    margin: 10,
    backgroundColor: runningColor,
    '&:hover': {
      backgroundColor: Colors.lightGreen['700']
    }
  },
  pauseButton: {
    margin: 10,
    backgroundColor: pauseColor,
    '&:hover': {
      backgroundColor: Colors.orange['600']
    }
  }
})
class ActionsBarComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    showModal: PropTypes.func.isRequired,
    prepareForPayment: PropTypes.func.isRequired
  }

  handleTransfertClick = e => {
    this.props.showModal(
      MODAL_CLIENT_SELECTION_TRANSFERT,
      this.props.transaction
    )
  }
  cancelTransaction = e => {
    this.props.showModal(
      MODAL_CLIENT_CANCEL_TRANSACTION,
      this.props.transaction
    )
  }
  handlePaymentClick = e => {
    this.props.prepareForPayment(this.props.transaction)
  }
  handleEditBar = e => {
    this.props.showModal(MODAL_CLIENT_BAR_MODAL, this.props.transaction)
  }
  render() {
    const { classes, transaction } = this.props
    const disabled = transaction.paymentReady
    return (
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between">
        <Grid item>
          <Button
            className={classes.button}
            onClick={this.handleEditBar}
            variant="raised"
            color="primary">
            <EditIcon color="inherit" />
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={disabled || !transaction.sale_id}
            className={classes.button}
            onClick={this.handleTransfertClick}
            variant="raised"
            color="primary">
            <SwapIcon color="inherit" />
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={!transaction.sale_id}
            className={classes.button}
            onClick={this.handlePaymentClick}
            variant="raised"
            color="primary">
            <ReceiptIcon color="inherit" />
          </Button>
        </Grid>
        {!transaction.products ? (
          <Grid item>
            <Button
              disabled={disabled || !transaction.sale_id}
              className={classes.button}
              variant="raised"
              size="small"
              onClick={this.cancelTransaction}
              color="secondary">
              <DeleteIcon color="inherit" />
            </Button>
          </Grid>
        ) : null}
      </Grid>
    )
  }
}

export default withStyles(styles)(ActionsBarComponent)



// WEBPACK FOOTER //
// ./src/routes/Bar/components/ActionsBarComponent.js